import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { NextSalesPotentialDto } from '../../registration/models';
import { UpsertSalesPotentialRequest } from '../../sales-potential/actions/sales-potential.actions';

@Injectable({
  providedIn: 'root',
})
export class SalesPotentialApiService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.APIM_BASE_URL}/arable-advice-service/next-sales-potentials`;

  getSalesPotentials(year: number): Observable<NextSalesPotentialDto[]> {
    return this.http.get<NextSalesPotentialDto[]>(this.baseUrl, {
      params: { year: year.toString() },
    });
  }

  deleteSalesPotential(id: number): Observable<unknown> {
    return this.http.delete<unknown>(`${this.baseUrl}/${id}`);
  }

  upsertSalesPotential(request: UpsertSalesPotentialRequest): Observable<NextSalesPotentialDto> {
    return this.http.post<NextSalesPotentialDto>(this.baseUrl, request);
  }
}
